import React, { useState } from 'react'
import PortfolioConfig from '../../portfolio/PortfolioConfig'
import StrategywiseUsers from './StrategywiseUsers'
import { AddDeleteStrategyForAll } from './AddDeleteStrategyForAll'
import { ROLE } from '../../util/constant'
import CopyUserStrategies from '../../portfolio/CopyUserStrategies'
import { UserManagement } from './UserManagement'
import { UserBrokerAccountManagement } from './UserBrokerAccountManagement'
import { useEffect } from 'react'
import ATSnackbar from '../../layout/ATSnackbar'

const Manage = ({ user }) => {
    // When we add a strategy for all active users in <AddDeleteStrategyForAll /> component..
    // ... we also need to refresh the strategies in <PortfolioConfig /> to reflect latest data
    const [reloadUserStrategies, setReloadUserStrategies] = useState(false)

    const reloadPortfolioStrategies = () => setReloadUserStrategies(prev => !prev)

    const isAdmin = user?.role === ROLE.ADMIN

    // Common api call since 2 components need users data
    const [users, setUsers] = useState()

    const [alert, setAlert] = useState({
        message: '',
        open: false,
        severity: 'error'
    })

    const fetchAllUsers = () => {
        fetch(`/algo-trading/api/admin/users?masked=false&activeOnly=false`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                'Authorization': user?.credential,
            }
        })
            .then(function (response) {
                response.text().then(r => {
                    if (response.ok) {
                        setUsers(JSON.parse(r))
                    } else {
                        console.log('FAIL', r)
                        setAlert({
                            message: 'Error fetching users: ' + response?.message,
                            open: true,
                            severity: 'error'
                        })
                    }
                })
            }, function (error) {
                console.log('ERROR', error.message)
                setAlert({
                    message: 'Error fetching users: ' + error.message,
                    open: true,
                    severity: 'error'
                })
            })
    }

    useEffect(() => {
        if (!isAdmin)
            return

        fetchAllUsers()
    }, [user])

    const setOpen = open => setAlert(prev => ({ ...prev, open }))

    return (
        <>
            <PortfolioConfig user={user} reloadUserStrategies={reloadUserStrategies} />

            {isAdmin && (
                <>
                    <AddDeleteStrategyForAll user={user} reloadPortfolioStrategies={reloadPortfolioStrategies} />
                    <CopyUserStrategies user={user} />
                    <StrategywiseUsers user={user} />
                    <UserBrokerAccountManagement user={user} users={users} setAlert={setAlert} />
                    <UserManagement user={user} users={users} setUsers={setUsers} setAlert={setAlert} fetchAllUsers={fetchAllUsers} />
                </>
            )}

            <ATSnackbar message={alert?.message} open={alert?.open} setOpen={setOpen} severity={alert?.severity} />
        </>
    )
}

export default Manage